export { InputTheme as DropdownTheme } from "../Input/theme"
export const TypeAheadSearchItemTheme = {
    baseStyle: {
        backgroundColor: "white",
        _focus: {
            backgroundColor: "primary.50"
        },
        _disabled: { backgroundColor: "muted.500" },
    },
    defaultProps: {
        padding: 8
    }
}